module.exports = __webpack_public_path__ + "img/villa-and-house.6ec1145.jpg";